const DEFAULT_NEAR_BOTTOM_THRESHOLD_PX = 200

/**
 * Whether an element is visible in the layout (not display:none / detached).
 * @param element {HTMLElement} - The element.
 * @returns {boolean} - Whether the element is visible.
 */
export function isElementVisible(element: HTMLElement | undefined): boolean {
  if (!element) return false

  return element.offsetParent !== null || element.getClientRects().length > 0
}

/**
 * Whether the viewport has been scrolled and is near the bottom.
 * @param element {HTMLElement} - The element.
 * @param thresholdPx {number} - The threshold in pixels.
 * @returns {boolean} - Whether the viewport is near the bottom.
 */
export function isNearScrollBottom(element: HTMLElement, thresholdPx = DEFAULT_NEAR_BOTTOM_THRESHOLD_PX): boolean {
  const remaining = element.scrollHeight - element.scrollTop - element.clientHeight
  return element.scrollTop > 0 && remaining < thresholdPx
}

/**
 * Whether scrollable content overflows the viewport.
 * @param element {HTMLElement} - The element.
 * @returns {boolean} - Whether the viewport is overflowing.
 */
export function isViewportOverflowing(element: HTMLElement): boolean {
  return element.scrollHeight > element.clientHeight + 1
}
